import React from 'react';
import PropTypes from 'prop-types';
import IconButton from 'material-ui/IconButton';

const TreatmentInstanceDialogHeader = ({ children, onClose }) => (
  <div className="header">
    <h5>{children}</h5>
    <IconButton iconClassName="allocateIcons" onClick={onClose}>
      &#xE5CD;
    </IconButton>
  </div>
);

TreatmentInstanceDialogHeader.propTypes = {
  children: PropTypes.node.isRequired,
  onClose: PropTypes.func.isRequired,
};

export default TreatmentInstanceDialogHeader;
